import React from 'react';
import Loader from 'components/Loader/Loader';
const styles = require('../styles.pcss');

const LoaderSection: React.FC<{ visible: boolean }> = ({ visible }) => {
  if (!visible) return null;
  return (
    <div className={styles.loaderContainer}>
      <Loader visible={true} />
    </div>
  );
};

export default LoaderSection;
